import { Reveal, SectionHeading } from "@/components/Reveal";

const PHASES = [
  {
    num: "01",
    title: "FIRST CHEEK",
    tag: "NOW BOARDING",
    items: [
      "Stealth launch on Solana",
      "1,000 cheek believers assemble",
      "Timeline double-take takeover",
    ],
  },
  {
    num: "02",
    title: "DOUBLE CHEEK",
    tag: "IN TRANSIT",
    items: [
      "DEX tools trending & listings",
      "Meme arsenal drop — sticker packs, gif engine",
      "CEX scouts caught staring",
    ],
  },
  {
    num: "03",
    title: "FULL MOON",
    tag: "FINAL DESTINATION",
    items: [
      "69,000 holders strong",
      "Community-funded PEPEBUTT animated shorts",
      "Merch drop — pants not included",
    ],
  },
];

export default function Roadmap() {
  return (
    <section id="roadmap" data-testid="roadmap-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading index="03" eyebrow="ROADMAP" title="EVERY PHASE GETS THICCER" testId="roadmap-heading" />

        <div className="mt-16 space-y-0">
          {PHASES.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.08}>
              <div
                data-testid={`roadmap-phase-${p.num}`}
                className="group grid grid-cols-[auto_1fr] items-start gap-6 border-t border-line py-10 transition-colors duration-300 last:border-b hover:bg-surface sm:grid-cols-[160px_1fr_auto] sm:gap-10 sm:px-4"
              >
                <span className="text-outline-faint glitch-hover font-vt text-6xl leading-none transition-colors sm:text-7xl">
                  {p.num}
                </span>
                <div>
                  <h3 className="font-display text-xl font-extrabold tracking-tight text-[#EDEDE4] uppercase sm:text-2xl">
                    {p.title}
                  </h3>
                  <ul className="mt-4 space-y-2">
                    {p.items.map((item) => (
                      <li
                        key={item}
                        className="flex items-start gap-3 text-sm text-[#9fb39f]"
                      >
                        <span className="mt-1 font-vt text-base text-neon">{">"}</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <span className="col-span-2 border border-line px-3 py-1 font-mono text-[10px] tracking-[0.25em] text-[#6b7f6b] uppercase group-hover:border-neon/50 group-hover:text-neon sm:col-span-1 sm:justify-self-end">
                  {p.tag}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
